module.exports = __webpack_public_path__ + "static/media/ImporterUseCase.80518777.svg";